import React from 'react';
import BBCodeParser from 'js-bbcode-parser';
import reactPreset from '@bbob/preset-react/es';
import { render as renderBBCode } from '@bbob/react/es/render';
import Tooltip from '@/common/utils/bbParser/Tooltip';
import Note from '@/common/utils/bbParser/Note';
import Link from '@/common/utils/bbParser/Link';
import ErrorBoundary from '@/common/utils/bbParser/Error';

const bbParser = BBCodeParser;

bbParser.add('\\[list=a\\](.+?)\\[/list\\]', '<ul>$1</ul>');
bbParser.add('\\[list=1\\](.+?)\\[/list\\]', '<ul>$1</ul>');

const parseBB = (value) => ({
  __html: bbParser.parse(value),
});

const hasBbMarkup = (value) =>
  typeof value === 'string' && /\[[a-z/][^\]]*\]/i.test(value);

const presets = reactPreset.extend((tags) => ({
  ...tags,
  tooltip: (node) => ({
    ...node,
    content: node.content,
    tag: (node) => <Tooltip {...node} />,
  }),
  note: (node) => ({
    ...node,
    content: node.content,
    tag: Note,
  }),
  link: (node) => ({
    ...node,
    content: node.content,
    tag: (node) => <Link {...node} />,
  }),
  br: (node) => ({
    ...node,
    content: node.content,
    tag: 'br',
  }),
  b: (node) => ({
    ...node,
    content: node.content,
    tag: 'b',
  }),
  i: (node) => ({
    ...node,
    content: node.content,
    tag: 'i',
  }),
  url: (node) => ({
    ...node,
    tag: () => {
      const url = Object.values(node.attrs)[0] || '';
      const target =
        url.startsWith('/') || url.includes('praedias') ? '_self' : '_blank';

      return (
        <a href={url} target={target}>
          {node.content}
        </a>
      );
    },
  }),
}));

const ReactBB = (content) => {
  if (!hasBbMarkup(content)) {
    return content;
  }

  return (
    <ErrorBoundary content={content}>
      <>{renderBBCode(content, [presets()])}</>
    </ErrorBoundary>
  );
};
window.ReactBB = ReactBB;
export { ReactBB, parseBB };
